import React, { Component } from 'react';

import OpinionInfo from './opinion/info';
import OpinionFiles from './opinion/files';

export default class Opinion extends Component {
	render() {
		const opinion = this.props.opinion;

		return (<div className="two-col-content-panel opinions-list">
				<OpinionInfo opinion={ opinion } />
				<OpinionFiles files={ opinion.files } id={ opinion.id } permalink={ opinion.opinion_permalink } title={ opinion.title } />
			</div>
		);
	}
}